import { configureStore } from "@reduxjs/toolkit";

import railsReducer from "./reducers/rails-reducer.ts";

export const createAppStore = (initialState = {}) => {
  return configureStore({
    reducer: {
      rails: railsReducer,
    },
    preloadedState: initialState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
        },
      }),
    devTools: process.env.NODE_ENV !== "production",
  });
};

export default createAppStore;
